import { fetchAuthSession } from 'aws-amplify/auth';

const API_URL = 'https://bvx0oeufzk.execute-api.us-east-1.amazonaws.com/prod';

async function getToken() {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString();
}

async function apiCall(endpoint, method = 'GET', body = null) {
  const token = await getToken();
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };
  if (body) options.body = JSON.stringify(body);
  const res = await fetch(`${API_URL}${endpoint}`, options);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

export const getDashboard = () => apiCall('/dashboard');
export const startDiagnostic = () => apiCall('/diagnostic', 'POST', { action: 'start' });
export const submitDiagnostic = (answers) => apiCall('/diagnostic', 'POST', { action: 'submit', answers });
export const startSession = () => apiCall('/session', 'POST', { action: 'start' });
export const submitSession = (answers) => apiCall('/session', 'POST', { action: 'submit', answers });
